<script setup>
import {useCurrentOrganization} from '@/composables/use-current-organization.js'
import {useAppTheme} from '@/composables/use-app-theme.js'

//Composables
const {organizationLogoUrl} = useCurrentOrganization()
const {theme} = useAppTheme()
</script>

<template>
  <div :class="$style.logo">
    <img
      v-if="organizationLogoUrl"
      :src="organizationLogoUrl"
      :class="$style.organizationLogo"
      alt="Logo"
    >
    <img
      v-else
      :src="`/logo-${theme}.svg`"
      :class="$style.aristLogo"
      alt="Logo"
    >
  </div>
</template>

<style module lang="scss">
.logo {
  font-size: 0;
}
.organizationLogo {
  height: 2.5rem;
}
.aristLogo {
  height: 3.5rem;
  margin-left: -1rem; /* Arist logo has built in padding */
}
</style>
